import Main from './Main'
import AppData from './AppData'

export { AppData }
export default Main